<template>
    <Header class="header">
        <div class="logo">
            <img src="../assets/Logoonly@2x.png">
        </div>
        <div class="title">
            {{type === 'digitalMap' && device === 'rn' ? 'Mapxus Map React Native SDK Doc' : 'Mapxus Map SDK Doc'}}
        </div>
    </Header>
</template>

<script>
	export default {
		name: 'DocumentHeader',
		props: {
			type: String,
			device: String
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header {
        color: white;
        background-color: rgb(118, 120, 122);
        padding: 0 20px;
        font-size: 1.2em;
        font-weight: bold;
        position: fixed;
        width: 100%;
        z-index: 1;
    }

    .logo {
        position: absolute;
        margin-top: 5px;
        margin-left: 5px;
    }

    .logo img {
        width: 41px;
        height: 25px;
    }

    .title {
        font-size: 20px;
        font-weight: 400;
        margin-left: 65px;
        font-family: 'verdana';
    }
</style>
